import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
`;

export const IconWrapper = styled.div`
	> button > li {
		padding: 0 !important;
	}
`;

export const Actions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
`;
